import { deleteCookie, getCookie } from 'cookies-next/client';

import { getUiConfig } from '@/config/client/getUiConfig';
import { MVPD_AUTH_COOKIE, XID_COOKIE } from '@/constants/cookies';
import { getUserInfo } from '@/features/auth/client/getUserInfo';
import { isMvpdAuthenticated } from '@/features/auth/isMvpdAuthenticated';
import { getAuthSDK } from '@/sdk/client/getAuthSDK';

export async function mvpdLogOut(): Promise<void> {
  try {
    const uiConfig = getUiConfig();
    const xid = getCookie(XID_COOKIE);
    const { accessToken } = getUserInfo();

    if (xid && isMvpdAuthenticated(accessToken)) {
      await getAuthSDK().logoutOfMVPDV3({ deviceId: xid, clientId: uiConfig.clientId });
      deleteCookie(MVPD_AUTH_COOKIE, {
        path: '/',
        domain: 'fox.com',
      });
    }
  } catch {}
}
